import React from "react";
import Department from "../../../types/Department";
import Resources from "../../../types/Resources";
import FilePicker from "./FilePicker";
import { PermitDocument } from "../../../types/permits";
import Button from "../../Common/Button";
import Link from "../../Common/Link";

type PermitActionBarProps = {
    permitDocument: PermitDocument;
    department: Department | undefined;
    requestInProgress: boolean;

    acceptPermitClickHandler: () => void;
    checkoutPermitClickHandler?: () => void;
    copyPermitClickHandler: () => void;
    renewPermitClickHandler?: () => void;
    rejectPermitClickHandler?: () => void;

    resources: Resources;
};

function PermitActionBar(props: PermitActionBarProps) {
    return (
        <div className="d-flex">
            {props.permitDocument.canAccept ? (
                <Button
                    className="me-2"
                    variant="success"
                    onClick={props.acceptPermitClickHandler}
                    disabled={props.requestInProgress}
                >
                    {props.resources.get("Accept")}
                </Button>
            ) : null}
            {(props.permitDocument as any).canReject ? (
                <Button
                    className="btn btn-danger me-2"
                    onClick={props.rejectPermitClickHandler}
                    disabled={props.requestInProgress}
                >
                    {props.resources.get("Reject")}
                </Button>
            ) : null}
            {(props.permitDocument as any).canCheckout ? (
                <Button
                    className="btn btn-success ps-4 pe-4 me-2"
                    onClick={props.checkoutPermitClickHandler}
                    disabled={props.requestInProgress}
                >
                    {props.resources.get("CheckOut")}
                </Button>
            ) : null}
            {!!props.department && props.department.canCreatePermits ? (
                <Button
                    className="btn btn-secondary ps-4 pe-4 me-2"
                    tooltip={props.resources.get("CopyOldToNew")}
                    onClick={props.copyPermitClickHandler}
                    disabled={props.requestInProgress}
                >
                    <i className="fas fa-file"></i>
                </Button>
            ) : null}
            {(props.permitDocument as any).canRenew ? (
                <Button
                    className="btn btn-secondary ps-4 pe-4 me-2"
                    tooltip={props.resources.get("RenewPermit")}
                    onClick={props.renewPermitClickHandler}
                    disabled={props.requestInProgress}
                >
                    <i className="fas fa-timer"></i>
                </Button>
            ) : null}
            <Link
                className="btn btn-secondary ps-4 pe-4 me-2"
                href={`/api/workPermits/pdf/${props.permitDocument.entityId}`}
                tooltip={props.resources.get("Print")}
                newPage={true}
            >
                <i className="fas fa-print"></i>
            </Link>
            <FilePicker
                resources={props.resources}
                storedPermit={props.permitDocument}
                canManageAttachments={props.permitDocument.canManageAttachments}
            />
        </div>
    );
}

export default PermitActionBar;
